export const menu_1 = {

    title: 'TagPlus',
    itens: [
      {
        title: 'Quem Somos',
        href: 'https://www.tagplus.com.br/sobre/',
        target: '__blank',
      },
      {
        title: 'Trabalhe Conosco',
        href: 'https://vagas.tagplus.com.br/',
        target: '__blank',
      },
      {
        title: 'Ajuda TagPlus',
        href: 'https://ajuda.tagplus.com.br/',
        target: '__blank',
      },
      {
        title: 'Termos de Uso',
        href: 'https://www.tagplus.com.br/termos-de-uso/',
        target: '__blank',
      },
    ]
}
export const menu_2 = {
    title: 'Conteúdo',
    itens: [
      {
        title: 'Blog da Tag',
        href: 'https://blog.tagplus.com.br/',
        target: '__blank',
      },
      {
        title: 'Loja de Aplicativos',
        href: 'https://aplicativos.tagplus.com.br/',
        target: '__blank',
      },
      {
        title: 'TagPlus no Android',
        href: '',
        target: '__blank',
      },
      {
        title: 'TagPlus no iOS',
        href: '',
        target: '__blank',
      },
    ]
}

export const contacts = {
  title: 'Entre em Contato',
  itens: [
    {
      estado: 'Minas Gerais',
      phone: '(31) 4042-1130'
    },
    {
      estado: 'Rio Grande do Sul',
      phone: '(51) 4042-1307'
    },
    {
      estado: 'Bahia',
      phone: '(71) 4042-1788'
    },
    {
      estado: 'Santa Catarina',
      phone: '(48) 4042-1733'
    },
    {
      estado: 'São Paulo',
      phone: '(11) 4210-0233'
    },
    {
      estado: 'Paraná',
      phone: '(41) 4042-1820'
    },
    {
      estado: 'Rio de Janeiro',
      phone: '(21) 2042-0244'
    },
    {
      estado: 'Brasília',
      phone: '(61) 4042-1799'
    },
  ]
}